import { Alert, AlertDescription, AlertIcon, VStack } from "@chakra-ui/react";
import { PatientId } from "../../../shared/schema/schema";
import MedicalDiagnosisCodeTable from "../../patient/components/MedicalDiagnosisCodeTable";

/**
 * Diagnosis codes are patient records that also appear on the finalized service
 * plan, so this step reuses the patient profile's own table — editable here, and
 * edits show up on the Medical tab too. Not locked when the plan is finalized:
 * the plan snapshots these at finalize time, while the patient's records keep
 * living on.
 */

interface Props {
  patientId: PatientId;
}

export default function ServicePlanDiagnosisCodesStep({ patientId }: Props) {
  return (
    <VStack align="stretch" spacing={4}>
      <Alert status="info">
        <AlertIcon />
        <AlertDescription>
          These are the patient&apos;s diagnosis codes — edits here also apply on the Medical
          Diagnosis Codes tab. They are included on the finalized service plan.
        </AlertDescription>
      </Alert>
      <MedicalDiagnosisCodeTable patientId={patientId} />
    </VStack>
  );
}
